module.exports = __webpack_public_path__ + "static/media/kex-min.4f3687bf.png";